import { Input, Modal, message } from "antd";
import { useEffect, useState } from "react";
import { RELOAD_ERROR_CODES } from "features/ConsultRequest/core/constants";
import { addNote } from "features/ConsultRequest/data/apiAdapters";
import { useConsultCall } from "features/ConsultRequest/data/hooks";

export const NOTE_MAX_LENGTH = 1000;
export const NOTE_REQUIRED_MESSAGE = "Vui lòng nhập nội dung ghi chú";

export default function AddNoteModal({ visible, requestId, onClose, onAdded, onStale }) {
  const { call } = useConsultCall();
  const [content, setContent] = useState("");
  const [touched, setTouched] = useState(false);
  const [saving, setSaving] = useState(false);
  const empty = !content.trim();

  useEffect(() => {
    if (visible) {
      setContent("");
      setTouched(false);
    }
  }, [visible]);

  const submit = async () => {
    if (empty) {
      setTouched(true);
      return;
    }
    setSaving(true);
    try {
      await call(addNote, requestId, content.trim());
      onAdded?.();
      onClose();
    } catch (e) {
      // Giữ nguyên nội dung khi lỗi.
      message.error(e.message);
      if (RELOAD_ERROR_CODES.includes(e.code)) {
        onStale?.();
        onClose();
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Thêm ghi chú nội bộ"
      visible={visible}
      onCancel={onClose}
      onOk={submit}
      okText="Lưu ghi chú"
      cancelText="Hủy"
      okButtonProps={{ loading: saving }}
      destroyOnClose
    >
      <div style={{ marginBottom: 4 }}>Nội dung ghi chú *</div>
      <Input.TextArea
        rows={5}
        maxLength={NOTE_MAX_LENGTH}
        value={content}
        status={touched && empty ? "error" : undefined}
        style={touched && empty ? { borderColor: "#D8001A" } : undefined}
        onChange={(e) => setContent(e.target.value)}
        onBlur={() => setTouched(true)}
      />
      <div style={{ textAlign: "right", color: "#8c8c8c" }}>{`${content.length}/${NOTE_MAX_LENGTH}`}</div>
      {touched && empty && <div style={{ color: "#D8001A" }}>{NOTE_REQUIRED_MESSAGE}</div>}
    </Modal>
  );
}
